/**
 * Route parsing for the shared strategic-analysis screen.
 *
 * Separate from the screen because it is pure, and because a test that wants to
 * check "what does `?tab=../admin` do" should not have to mount a React tree and
 * a Supabase client to find out.
 *
 * THE PARAMETER SELECTS DATA AND GRANTS NOTHING. There is no `canEdit`, no
 * `role`, no `persona` here and there never should be — authority is resolved
 * from server-backed membership, and a route parameter is attacker-controlled by
 * definition.
 */

import { ANALYSIS_TABS, type AnalysisType } from './types';

/**
 * An unknown or absent tab falls back rather than erroring.
 *
 * A hand-typed, truncated or stale link is normal input. It should open the
 * first analysis, not a blank screen.
 */
export function parseAnalysisTab(raw: unknown): AnalysisType {
  return typeof raw === 'string' && (ANALYSIS_TABS as readonly string[]).includes(raw)
    ? (raw as AnalysisType)
    : 'competition';
}
